import { prefetchLink } from '@utils';
import { f as fetchHTML } from './index-Da0J-i1G.js';
import { T } from './index-BUFn6WSj.js';
import './index.esm-Pk8qng7t.js';

/**
 * Custom element that implements infinite scrolling functionality
 * Observes the last item in a list and loads more content when it becomes visible
 */
class InfiniteLoad extends HTMLElement {
  nextUrl = this.dataset.nextUrl;
  list = this.querySelector('ul');
  listItems = [...this.list.querySelectorAll('[data-products-list] > li:not([data-promo-block])')];
  lastItem = this.listItems[this.listItems.length - 1];
  previousLastItem = null;
  observer;
  html;

  connectedCallback() {
    this.initIntersectionObserver();
  }

  /**
   * Initializes the intersection observer to watch the last item
   * Triggers loadMore when the last item becomes visible
   */
  initIntersectionObserver() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        entry.isIntersecting && this.loadMore();
      },
      {
        root: null,
        rootMargin: '100%',
        threshold: 0,
      }
    );

    this.observer.observe(this.lastItem);
  }

  /**
   * Loads more items when the last item becomes visible
   * Manages the observer and updates the list with new content
   */
  async loadMore() {
    if (!this.nextUrl) return;

    this.previousLastItem = this.lastItem;
    this.observer.unobserve(this.previousLastItem);

    await this.fetchHtml();
    this.appendNewProducts();
    this.updateNextUrl();

    this.nextUrl && this.initIntersectionObserver();
  }

  /**
   * Fetches the next page of HTML content
   */
  async fetchHtml() {
    try {
      this.html = await fetchHTML(this.nextUrl);
    } catch (error) {
      console.error('Failed to fetch more content:', error);
    }
  }

  /**
   * Appends new products to the list and updates the last item reference
   */
  appendNewProducts() {
    const items = this.html.querySelectorAll('infinite-load ul > li:not([data-promo-block])');

    items.forEach((item) => {
      // Remove inline display and visibility styles
      const images = item.querySelectorAll('img');
      images.forEach((img) => {
        img.style.removeProperty('display');
        img.style.removeProperty('visibility');
      });

      const link = item.querySelectorAll('a');

      link.forEach((link) => {
        T.instance.register({
          element: link,
          name: `prefetch-${link.href}`,
          callback: () => prefetchLink(link),
        });
      });
    });

    this.lastItem = items[items.length - 1];
    this.list.append(...items);
  }

  /**
   * Updates the next URL from the fetched HTML
   * Sets nextUrl to undefined if no more content is available
   */
  updateNextUrl() {
    const { nextUrl } = this.html.querySelector('infinite-load[data-next-url]').dataset;
    this.nextUrl = nextUrl || undefined;
  }
}

customElements.define('infinite-load', InfiniteLoad);
